export default "__VITE_ASSET__Bn$NcAy2__"